<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup"><v-icon>mdi-close</v-icon></v-btn></v-card-title
        >
      </div>
      <v-card-text class="pa-4" style="max-height: 70vh; overflow-y: auto">
        <label class="label-input">Section Name</label>
        <v-row>
          <v-col cols="12" md="8"><v-text-field v-model="fields.title" label="Name"/></v-col>
          <v-col cols="12" md="4"><v-checkbox v-model="fields.enableAnchor" label="Enable Anchor"/></v-col>
        </v-row>
        <label class="label-input">Header</label>
        <div class="group-item">
          <ckeditor :editor="editor" v-model="fields.header" :config="editorConfig" />
        </div>
        <div class="mt-6">
          <div class="d-flex justify-space-between align-center mb-4">
            <label class="label-input mb-0">Timeline</label
            ><v-btn small color="primary" @click="handleAddItem"><v-icon size="16">mdi-plus</v-icon>Add Item</v-btn>
          </div>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="4">
                <ColorPicker
                  v-model="fields.cardBgColor"
                  name="tryher-timeline-card-bg"
                  label="Card Background"
                  default-color="#FFF7FC"
                />
              </v-col>
              <v-col cols="12" md="4">
                <ColorPicker
                  v-model="fields.cardTextColor"
                  name="tryher-timeline-card-text"
                  label="Card Text"
                  default-color="#1F1F1F"
                />
              </v-col>
              <v-col cols="12" md="4">
                <ColorPicker
                  v-model="fields.cardBorderColor"
                  name="tryher-timeline-card-border"
                  label="Card Border"
                  default-color="#1F1F1F"
                />
              </v-col>
              <v-col cols="12" md="6">
                <ColorPicker
                  v-model="fields.lineColor"
                  name="tryher-timeline-line"
                  label="Timeline Color"
                  default-color="#f96da3"
                />
              </v-col>
              <v-col cols="12" md="6">
                <ColorPicker
                  v-model="fields.lineBorderColor"
                  name="tryher-timeline-line-border"
                  label="Timeline Border"
                  default-color="#1F1F1F"
                />
              </v-col>
            </v-row>
            <v-expansion-panels accordion class="mt-4">
              <v-expansion-panel v-for="(item, index) in fields.listItem" :key="`timeline-${index}`">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <span>Item {{ index + 1 }}</span>
                    <v-btn icon @click.stop="handleRemoveItem(index)">
                      <v-icon color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <label class="d-block mb-2">Title</label>
                  <ckeditor :editor="editor" v-model="item.title" :config="editorConfig" />
                  <label class="d-block my-2">Content</label>
                  <ckeditor :editor="editor" v-model="item.content" :config="editorConfig" />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
        <SectionSettingsContainerFuild
          class="mt-6"
          :settings="fields.settings"
          :containerPage="fields.containerPage"
          :showBackgroundImage="false"
          :showContainerPage="false"
        />
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer />
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import ColorPicker from './common/color-picker.vue';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';

const defaultItem = () => ({
  title: '<h2><strong>Days 1-7</strong></h2><p>First Thing You Notice</p>',
  content: '<p>Add the timeline result here.</p>',
});
export default {
  name: 'TryherTimeline',
  components: { ColorPicker, SectionSettingsContainerFuild },
  props: { sectionEditor: { type: Object, required: true } },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Tryher timeline',
        enableAnchor: false,
        header: '',
        listItem: [],
        cardBgColor: '#FFF7FC',
        cardTextColor: '#1F1F1F',
        cardBorderColor: '#1F1F1F',
        lineColor: '#f96da3',
        lineBorderColor: '#1F1F1F',
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#FFFFFF',
          textColor: '#1F1F1F',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
        },
        containerPage: { enableStyle: false, background: '#FFFFFF' },
      },
    };
  },
  mounted() {
    const extract = this.sectionEditor.sectionExtract || {};
    this.fields = {
      ...this.fields,
      ...extract,
      settings: { ...this.fields.settings, ...(extract.settings || {}) },
      containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
      listItem: (extract.listItem || []).map(item => ({ ...defaultItem(), ...item })),
    };
  },
  methods: {
    handleAddItem() {
      this.fields.listItem.push(defaultItem());
    },
    handleRemoveItem(index) {
      this.fields.listItem.splice(index, 1);
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const html = updateHtmlFromData.sectionTryherTimeline(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html,
      });
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.label-input {
  display: block;
  margin-bottom: 10px;
  color: #000;
  font-size: 18px;
  font-weight: 500;
}
.group-item {
  padding: 15px 10px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
}
.header-modal,
.footer-modal {
  position: sticky;
  left: 0;
  z-index: 999;
  padding: 0 16px;
  background: #fff;
  box-shadow: 0 0 12px #0000000f;
}
.header-modal {
  top: 0;
}
.footer-modal {
  bottom: 0;
}
</style>
